export default __webpack_public_path__ + "c9675a83d367a6a7e5858a7ffa5f1577.svg";